import { Component, OnInit, OnDestroy } from '@angular/core';
import { FirstTimeLoginService } from './firstTimeLogin.service';
import { PasswordHintQuestionEntity, SubmitRequiredUserInformationRequestModel, RequiredInformationModel, SubmitRequiredUserInformationResponseModel, MessageModel } from '../../model/models';
import { Subscription } from 'rxjs';
import { LoginService } from '../login/login.service';
import { Router } from '@angular/router';
import { StorageService } from '../../shared/security/StorageService';
import { CurrentPageWatcherService } from '../../shared/utils/CurrentPageWatcher';
import * as $ from 'jquery';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { TransactionsService } from '../../transactions/transactions.service';

@Component({
  selector: 'app-first-time-login',
  templateUrl: './first-time-login.component.html',
  styleUrls: ['./first-time-login.component.css']
})
export class FirstTimeLoginComponent implements OnInit,OnDestroy {
  
  agree: boolean = false;  
  termsandConditions: boolean = false;
  submittedAgree: boolean = false;
  confirmPassword1:string='';
  
  public isConnected: boolean = false;
  submitted = false;

  submitRequiredUserInformationModel = new SubmitRequiredUserInformationRequestModel();
  requiredUserinformationModel = new RequiredInformationModel();
  questionList: Array<PasswordHintQuestionEntity> =[];
  userMessages: Array<MessageModel> = [];
  requiredUserInformationSubscription: Subscription;
  
  constructor(private firstTimeLoginService:  FirstTimeLoginService, 
              private currentPageWatcherService: CurrentPageWatcherService,
              private loginService : LoginService,
              private spinner: SpinnerService,
              private router : Router,
              private storage: StorageService,
              private transactionService : TransactionsService) {

    this.requiredUserInformationSubscription = this.loginService.notifyRequiredUserInformation.subscribe(
      (reqUser:RequiredInformationModel )=>{
        this.requiredUserinformationModel=reqUser;
        console.log("Model",reqUser)
      }
    );

   }

  ngOnInit() {
    this.currentPageWatcherService.pageChanged().emit("Terms And Conditions");
    this.firstTimeLoginService.getPwdHintQuestionList()
    .subscribe((resp: Array<PasswordHintQuestionEntity>)=>{
      console.log("questions resp ",resp);
      this.questionList=resp;
      this.submitRequiredUserInformationModel.PasswordHintQuestionID = this.questionList[0].PasswordHintQuestionID;

    },
    err=>{
      if(err.status==500){
        console.log("ADRE application axception");
      }
    });

  }

  termsAndConditionAccept(agreeForm){
    this.submittedAgree = true;
    if(agreeForm && this.agree){
    this.termsandConditions = true;
    this.currentPageWatcherService.pageChanged().emit("Enter Required Information");
   console.log("Agree Terms and Conditions.")
  }
  else{
    $("html, body").animate({ scrollTop: 0 }, "slow");
  }
}
 
onSubmit(firstTimeForm) {
  this.currentPageWatcherService.sendUserMessages(null);
  this.submitted = true;
  // if(firstTimeForm.valid){    
    this.submitRequiredUserInformationModel.EmailAddressSpecified=this.requiredUserinformationModel.EmailAddress;
    this.submitRequiredUserInformationModel.PasswordInformationSpecified=this.requiredUserinformationModel.Password;
    this.submitRequiredUserInformationModel.TermsAcceptedSpecified=this.requiredUserinformationModel.AcceptTermsAndConditions;
    this.submitRequiredUserInformationModel.SessionID=this.storage.getSessionData().userSessionId;
    this.submitRequiredUserInformationModel.TermsAccepted=this.agree;
    console.log("submitRequiredUserInformationModel ", this.submitRequiredUserInformationModel);
    this.firstTimeLoginService.firstTimeLogin(this.submitRequiredUserInformationModel)
    .subscribe(
      (requiredUserInfoResponse: SubmitRequiredUserInformationResponseModel)=>{
        console.log("requiredUserInfoResponse ", requiredUserInfoResponse);
        if(requiredUserInfoResponse.UserMessages!=undefined){
        
         requiredUserInfoResponse.UserMessages.forEach(el=>{
            this.userMessages.push(el);
        });
      }
        this.currentPageWatcherService.sendUserMessages(this.userMessages);
        //no error 
        if (requiredUserInfoResponse.Summary == 0) {
           this.isConnected = true;
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
        else{
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];

        }
      },
      // (err)=>{
      //   if (err.error && err.error.UserMessages != undefined) {
      //     err.error.UserMessages.forEach(element => {
      //       this.userMessages.push(element)
      //     });
         
      //   }
      //   else {
      //     let userMsg : MessageModel;
      //     userMsg.Alert=3;
      //     userMsg.Description=err.message; 
      //     this.userMessages.push(userMsg)

      //   }
      //   $("html, body").animate({ scrollTop: 0 }, "slow");
      //   this.currentPageWatcherService.sendUserMessages(this.userMessages);
      //   this.userMessages=[];
      //   this.spinner.hide();
      // }
    )
    // }
    // else{
    //   $("html, body").animate({ scrollTop: 0 }, "slow");
    // }
  }

  ngOnDestroy(): void {
    this.requiredUserInformationSubscription.unsubscribe();
    this.currentPageWatcherService.clearUserMessage();
     

  }
}



// WEBPACK FOOTER //
// ./src/app/login/first-time-login/first-time-login.component.ts